import { render, staticRenderFns } from "./PrescriptionErrorAlert.vue?vue&type=template&id=4325ecac&scoped=true&"
import script from "./PrescriptionErrorAlert.vue?vue&type=script&lang=js&"
export * from "./PrescriptionErrorAlert.vue?vue&type=script&lang=js&"
import style0 from "./PrescriptionErrorAlert.vue?vue&type=style&index=0&id=4325ecac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4325ecac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
